import { format, subHours } from "date-fns";
import { OptionCard } from "../../../common-ui/OptionCard";
import CalendarTodayIcon from "@mui/icons-material/CalendarToday";
import { DateTimePicker } from "@mui/x-date-pickers-pro";
import { useTranslation } from "react-i18next";
import { Dispatch, SetStateAction, useState } from "react";

type DateTimeCardProps = {
  selectedDate: Date;
  disabled?: boolean;
  selected?: boolean;
  clearable?: boolean;
  setSelectedDate: Dispatch<SetStateAction<Date>>;
};

const DateTimeCard = ({
  selectedDate,
  disabled,
  selected,
  clearable,
  setSelectedDate
}: DateTimeCardProps) => {
  return (
    <OptionCard
      avatarContent={<CalendarTodayIcon />}
      title={format(selectedDate, `PPPPpppp`)}
      setOption={setSelectedDate}
      clearable={clearable}
      disabled={disabled}
      selected={selected}
    />
  );
};

type DateTimeSelectProps = {
  selectedDate?: Date;
  setSelectedDate: Dispatch<SetStateAction<Date>>;
  disabled?: boolean;
  creationDurationHours?: number;
};

export const DateTimeSelect = ({
  selectedDate,
  disabled,
  setSelectedDate,
  creationDurationHours = 72
}: DateTimeSelectProps) => {
  const { t } = useTranslation();
  const earliestTimeAvailable = subHours(new Date(), creationDurationHours);

  const [open, setOpen] = useState(false);

  if (selectedDate) {
    return (
      <DateTimeCard
        selectedDate={selectedDate}
        disabled={disabled}
        setSelectedDate={setSelectedDate}
        selected
        clearable
      />
    );
  }
  return (
    <DateTimePicker
      open={open}
      onOpen={() => setOpen(true)}
      onClose={() => setOpen(false)}
      sx={{ width: "100%" }}
      disabled={disabled}
      label={t("Date & Time")}
      value={selectedDate}
      minDate={earliestTimeAvailable}
      maxDateTime={new Date()}
      closeOnSelect={false}
      onAccept={(newValue) => setSelectedDate(newValue || new Date())}
      onChange={(newValue) => {
        if (!newValue) {
          setSelectedDate(new Date());
        }
      }}
      slotProps={{
        textField: {
          onClick: () => {
            if (!disabled) {
              setOpen(true);
            }
          }
        }
      }}
    />
  );
};
